import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import orderBy from 'lodash/orderBy';
import { capacityDisplayLogic } from 'shared/helpers';

const TcEventCapacity = ({ locations, capacityTypes }) => {
  const { t } = useTranslation();
  return (
    <section className="tc-event-capacity-section">
      {locations.length ? (
        <div>
          {locations.map((location, idx) => (
            <div key={`location-${idx}`} className="mb-3">
              <div className="text-strong">
                {location.name}
                {location.area && location.area.length > 0 && `, ${location.area}`}:{' '}
              </div>
              {orderBy(capacityTypes, 'displayOrder', 'asc').map(
                (type) =>
                  capacityDisplayLogic(location, type) && (
                    <div key={`type-${idx}-${type.id}`}>
                      <span> {type.name}: </span>
                      {capacityDisplayLogic(location, type)}
                    </div>
                  )
              )}
            </div>
          ))}
        </div>
      ) : (
        <p>{t('testCenter.eventDashboard.noLocationsLabel')}</p>
      )}
    </section>
  );
};

export default TcEventCapacity;

TcEventCapacity.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
